import script from "./HelpPage.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpPage.vue?vue&type=script&setup=true&lang=js"

import "./HelpPage.vue?vue&type=style&index=0&id=30da91e8&lang=scss"

const __exports__ = script;

export default __exports__